import { Button } from '../ui/button';
import { Input } from '../ui/input';
import styles from "../../styles/base/Login.module.scss";
import { useState } from "react";
import ErrorForm from './ErrorForm';
import happy_emoji from "../../assets/base/happy_emoji.png";
import { getContent } from '../../functions/general/translations';
import { useAppSelector } from '../../hooks/redux';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import axios from 'src/axios/axios';
import { Loader2 } from 'lucide-react';

export default function ForgotPasswordForm({...props}){
    const { onBack } = props;
    const {t} = useTranslation()
    const [responseRequest, setresponseRequest] = useState({errorcode:'', message:''});
    const [requestemail, setrequestemail] = useState('');

    const { mutate:handleRequestPassword, isLoading, isError, reset } = useMutation({
        mutationFn: async () => {
            const {data} = await axios.get(`password/request?email=${requestemail}`)
            setresponseRequest(data)
            if(data.errorcode!==0){throw new Error(data.message)}
        },
        onError: () => { setTimeout(()=>{reset()}, 2000) }
    })


    return (
        <div className={styles.loginform}>

            {responseRequest.errorcode === '' &&
            <div className={styles.loginform_wrapper}>
                <div className={styles.content}>
                    
                    <Button onClick={()=>{onBack()}} variant='secondary' className='mb-4'>{t("ForgotPasswordForm.back_button")}</Button>

                    <h1 className='text-2xl font-bold'>{t("ForgotPasswordForm.title")}</h1>
                    <p className={styles.description}>{t("ForgotPasswordForm.description")}</p>
                </div>

                <div className={styles.input}>
                    <p className={styles.label}>{t("ForgotPasswordForm.email_label")}</p>
                    <Input onChange={(e)=>{setrequestemail(e.currentTarget.value)}} type="email" placeholder="patrick@voorbeeld.be"/>
                </div>

                <Button className={`${isError && 'bg-red-700'}`} disabled={isLoading} onClick={()=>{handleRequestPassword()}}>
                    {isError ? t('Er liep iets mis') :  (isLoading ? <Loader2 className='animate-spin w-4'/> : t("ForgotPasswordForm.submit_button"))}
                </Button>
            </div>
            }

            {parseFloat(responseRequest.errorcode) === 0 &&
                <div className={styles.loginform_wrapper}>
                    <div className={styles.content}>            
                        <img className={styles.emoji} src={happy_emoji} alt="happy emoji"/>    
                        <h1 className={styles.title}>{t('Uw aanvraag was succesvol')}</h1>
                        <p className={styles.description}>{t('Binnen enkele ogenblikken zal u een e-mail ontvangen om uw wachtwoord opnieuw in te stellen')}</p>
                    </div>

                    <Button onClick={()=>{onBack()}}>{t('Naar het inlogscherm')}</Button>
                </div>
            }

            {(responseRequest.errorcode !== '' && parseFloat(responseRequest.errorcode) !== 0) &&
            <div className={styles.loginform_wrapper}>
                <ErrorForm error={responseRequest} onBack={()=>{onBack()}}/>
            </div>
            }
            
        </div>
    )
}